import { Fragment, useMemo } from 'react'
import BookMeetingContent from './types/BookMeetingContent';

import useEntityStore from 'store/entityStore';
import CheckoutScript from 'components/CheckoutScript';

export default function FullCheckoutContent({isStandalone = false}) {
  const entity = useEntityStore(state => state.entity?.data);

  const _Content = useMemo(() => {
    let Content;
    
    switch (entity?.type) {
      case "one_to_one_meeting":
        Content = BookMeetingContent;
        break;
      case "channel": // TODO
      case "course": // TODO
      case "premium_content": // TODO
      default:
        Content = null;
    }

    return Content;
  }, [entity?.type]);

  return (
    <>
    <CheckoutScript />
    {_Content && <_Content isStandalone={isStandalone}/>}
    </>
  )
}